import {
  GET_EXCO_PUSAT,
  GET_EXCO_PUSAT_SUCCESS,
  GET_EXCO_PUSAT_FAIL,
  GET_DETAIL_EXCO_PUSAT,
  GET_DETAIL_EXCO_PUSAT_SUCCESS,
  GET_DETAIL_EXCO_PUSAT_FAIL,
  PATCH_EXCO_PUSAT,
  PATCH_EXCO_PUSAT_SUCCESS,
  PATCH_EXCO_PUSAT_FAIL,
  GET_EXCO_RTRW,
  GET_EXCO_RTRW_SUCCESS,
  GET_EXCO_RTRW_FAIL,
  GET_EXCO_PUK,
  GET_EXCO_PUK_SUCCESS,
  GET_EXCO_PUK_FAIL,
  CREATE_EXCO_PUK,
  CREATE_EXCO_PUK_SUCCESS,
  CREATE_EXCO_PUK_FAIL,
  CREATE_EXCO_RTRW,
  CREATE_EXCO_RTRW_SUCCESS,
  CREATE_EXCO_RTRW_FAIL,
} from "./actionTypes";
import { API } from "../../API/api";

// get exco table
export const getExcoPusat = () => (dispatch) => {
  dispatch({
    type: GET_EXCO_PUSAT,
  });

  const request = API.getExcoPusat();
  return request.then(
    (response) => dispatch(getExcoPusatSuccess(response.data)),
    (err) => dispatch(getExcoPusatFail(err)),
  );
};

export const getExcoPusatSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_PUSAT_SUCCESS,
    payload: data,
  });
};

export const getExcoPusatFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_PUSAT_FAIL,
    payload: data,
  });
};

// get exco detail
export const getDetailExcoPusat = (idTingkatExco, idDaerah) => (dispatch) => {
  dispatch({
    type: GET_DETAIL_EXCO_PUSAT,
  });
  const request = API.getDetailExcoPusat(idTingkatExco, idDaerah);
  return request.then(
    (response) => dispatch(getDetailExcoPusatSuccess(response.data)),
    (err) => dispatch(getDetailExcoPusatFail(err)),
  );
};

export const getDetailExcoPusatSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_DETAIL_EXCO_PUSAT_SUCCESS,
    payload: data,
  });
};

export const getDetailExcoPusatFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_DETAIL_EXCO_PUSAT_FAIL,
    payload: data,
  });
};

// patch alamat kantor
export const patchExcoDetail = (id, data) => (dispatch) => {
  dispatch({
    type: PATCH_EXCO_PUSAT,
  });

  const request = API.patchAddressOffice(id, data);
  return request.then(
    (response) => dispatch(patchExcoDetailSuccess(response.data)),
    (err) => dispatch(patchExcoDetailFail(err)),
  );
};

export const patchExcoDetailSuccess = (data) => (dispatch) => {
  return dispatch({
    type: PATCH_EXCO_PUSAT_SUCCESS,
    payload: data,
  });
};

export const patchExcoDetailFail = (data) => (dispatch) => {
  return dispatch({
    type: PATCH_EXCO_PUSAT_FAIL,
    payload: data,
  });
};

// get All rt rw
export const getExcoRTRW = (params) => (dispatch) => {
  dispatch({
    type: GET_EXCO_RTRW,
  });

  const request = API.getExcoRTRW(params);
  return request.then(
    (response) => dispatch(getExcoRTRWSuccess(response.data)),
    (err) => dispatch(getExcoRTRWFail(err)),
  );
};

export const getExcoRTRWSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_RTRW_SUCCESS,
    payload: data,
  });
};

export const getExcoRTRWFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_RTRW_FAIL,
    payload: data,
  });
};

// get Exco PUK
export const getExcoPUK = (params) => (dispatch) => {
  dispatch({
    type: GET_EXCO_PUK,
  });

  const request = API.getExcoPUK(params);
  return request.then(
    (response) => dispatch(getExcoPUKSuccess(response.data)),
    (err) => dispatch(getExcoPUKFail(err)),
  );
};

export const getExcoPUKSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_PUK_SUCCESS,
    payload: data,
  });
};

export const getExcoPUKFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_PUK_FAIL,
    payload: data,
  });
};

// create Exco PUK
export const createExcoPUK = (data) => (dispatch) => {
  dispatch({
    type: CREATE_EXCO_PUK,
  });

  const request = API.createExcoPUK(data);
  return request.then(
    (response) => dispatch(createExcoPUKSuccess(response.data)),
    (err) => dispatch(createExcoPUKFail(err)),
  );
};

export const createExcoPUKSuccess = (data) => (dispatch) => {
  return dispatch({
    type: CREATE_EXCO_PUK_SUCCESS,
    payload: data,
  });
};

export const createExcoPUKFail = (data) => (dispatch) => {
  return dispatch({
    type: CREATE_EXCO_PUK_FAIL,
    payload: data,
  });
};

// create Exco RTRW
export const createExcoRTRW = (data) => (dispatch) => {
  dispatch({
    type: CREATE_EXCO_RTRW,
  });

  const request = API.createExcoRTRW(data);
  return request.then(
    (response) => dispatch(createExcoRTRWSuccess(response.data)),
    (err) => dispatch(createExcoRTRWFail(err)),
  );
};

export const createExcoRTRWSuccess = (data) => (dispatch) => {
  return dispatch({
    type: CREATE_EXCO_RTRW_SUCCESS,
    payload: data,
  });
};

export const createExcoRTRWFail = (data) => (dispatch) => {
  return dispatch({
    type: CREATE_EXCO_RTRW_FAIL,
    payload: data,
  });
};
